import {
  createApi, createStore, createEvent, createEffect,
} from 'effector';
import { getApiKeySign, postMessageSign } from 'src/api/signatures';

// Events

export const setStepsBlockTopFn = createEvent('setStepsBlockTopFn');
export const setFirstStepOffsetFn = createEvent('setFirstStepOffsetFn');
export const setScrollYFn = createEvent('setScrollYFn');

export const setApiKeyFn = createEvent('setApiKeyFn');
export const getApiKeyFn = createEvent('getApiKeyFn');
export const postMessageFn = createEvent('postMessageFn');
export const setButtonTextFn = createEvent('setButtonTextFn');

// Stores

export const $allChipsView = createStore(false);

export const $stepsBlockTop = createStore(0);
export const $firstStepOffset = createStore(-1);
export const $scrollY = createStore(-2);

export const $appLoad = createStore(false);

export const $headerOpened = createStore(false);

export const $mobile = createStore(false);

export const $apiKey = createStore('');

export const $buttonText = createStore('Отправить бриф');

// Effects

export const getApiKeyFx = createEffect(getApiKeySign);
export const postMessageFx = createEffect(postMessageSign);

// Apis

export const appLoadApi = createApi($appLoad, {
  setLoad: () => true,
  setUnLoad: () => false,
});

export const mobileApi = createApi($mobile, {
  setMobile: () => true,
});

export const headerOpenedApi = createApi($headerOpened, {
  setOpen: () => true,
  setUnOpen: () => false,
});

export const allChipViewApi = createApi($allChipsView, {
  setVisible: () => true,
  setNotVisible: () => false,
});

export const chipFactory = () => {
  const $chipView = createStore(false);

  const chipViewApi = createApi($chipView, {
    setVisible: () => true,
    setNotVisible: () => false,
  });

  return {
    view: $chipView, api: chipViewApi,
  };
};
